<template>
  <div>
    <label v-if="label" class="data-label">{{label}}</label>
    <div class="color-picker__contianer" @click="handleOpenPicker">
      <span class="color-picker__placeholder">{{placeholder}}</span>
      <span class="color-picker__color">
        <span>{{value}}</span>
        <input-color-picker :id="id" v-model="model" />
      </span>
    </div>
  </div>
</template>

<script>
//https://dcustodio.github.io/vue-native-color-picker/
import InputColorPicker from 'vue-native-color-picker';

export default {
  name: 'CustomColorPicker',
  components: {
    InputColorPicker
  },
  props: {
    id: {
      type: String,
      default: `custom-color-picker-${Math.random()}`,
    },
    value: {
      type: String,
      default: '#000000',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Seleccione',
    },
  },
  data() {
    return {
      model: this.value,
    };
  },
  methods: {
    handleOpenPicker() {
      document
        .getElementById(this.id)
        .click();
    }
  },
  watch: {
    model(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.model = val;
    },
  },
};
</script>


<style lang="scss" scoped>
.color-picker__contianer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 39px;
  border: 1px solid rgba(60,60,60,0.26);
  background-color: white;
  border-radius: 3px;
  padding: 8px;
  cursor: pointer;
}

.color-picker__placeholder {
  color: #495057;
  opacity: .8;
  line-height: 1.6;
}

.color-picker__color {
  display: flex;
  min-width: 115px;
  align-items: center;
  justify-content: space-between;
  color: v-bind(value);
  text-transform: uppercase;
  font-weight: bold;
}

::v-deep .icp__input {
  height: 25px !important;
  width: 25px !important;
  background-color: v-bind(value) !important;
}
</style>